var _regeneratorRuntime = require("/media/data/Documents/code/javascript/mdxp/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/media/data/Documents/code/javascript/mdxp/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var unified = require('unified');

var toMDAST = require('remark-parse');

var remarkMdx = require('remark-mdx');

var footnotes = require('remark-footnotes');

var squeeze = require('remark-squeeze-paragraphs');

var visit = require('unist-util-visit');

var raw = require('hast-util-raw');

var toMDXAST = require('./md-ast-to-mdx-ast');

var mdxAstToMdxHast = require('./mdx-ast-to-mdx-hast');

var mdxHastToJsx = require('./mdx-hast-to-jsx');

var DEFAULT_OPTIONS = {
  remarkPlugins: [],
  rehypePlugins: [],
  compilers: []
};

function createMdxAstCompiler(options) {
  var mdPlugins = options.mdPlugins;
  var remarkPlugins = options.remarkPlugins;
  var plugins = mdPlugins || remarkPlugins;

  if (mdPlugins) {
    console.error("\n      @mdx-js/mdx: The mdPlugins option has been deprecated in favor of remarkPlugins\n                   Support for mdPlugins will be removed in MDX v2\n    ");
  }

  var fn = unified().use(toMDAST, options).use(remarkMdx, options).use(footnotes, options).use(squeeze, options).use(toMDXAST, options);
  plugins.forEach(function (plugin) {
    // Handle [plugin, pluginOptions] syntax
    if (Array.isArray(plugin) && plugin.length > 1) {
      fn.use(plugin[0], plugin[1]);
    } else {
      fn.use(plugin);
    }
  });
  fn.use(mdxAstToMdxHast, options);
  return fn;
}

function applyHastPluginsAndCompilers(compiler, options) {
  var hastPlugins = options.hastPlugins;
  var rehypePlugins = options.rehypePlugins;
  var plugins = hastPlugins || rehypePlugins;

  if (hastPlugins) {
    console.error("\n      @mdx-js/mdx: The hastPlugins option has been deprecated in favor of rehypePlugins\n                   Support for hastPlugins will be removed in MDX v2\n    ");
  }

  var compilers = options.compilers; // Convert raw nodes into HAST

  compiler.use(function () {
    return function (ast) {
      visit(ast, 'raw', function (node) {
        var _raw = raw(node),
            children = _raw.children,
            tagName = _raw.tagName,
            properties = _raw.properties;

        node.type = 'element';
        node.children = children;
        node.tagName = tagName;
        node.properties = properties;
      });
    };
  });
  plugins.forEach(function (plugin) {
    // Handle [plugin, pluginOptions] syntax
    if (Array.isArray(plugin) && plugin.length > 1) {
      compiler.use(plugin[0], plugin[1]);
    } else {
      compiler.use(plugin);
    }
  });
  compiler.use(mdxHastToJsx, options);

  var _iterator = _createForOfIteratorHelper(compilers),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var compilerPlugin = _step.value;
      compiler.use(compilerPlugin, options);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return compiler;
}

function createCompiler() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var opts = Object.assign({}, DEFAULT_OPTIONS, options);
  var compiler = createMdxAstCompiler(opts);
  var compilerWithPlugins = applyHastPluginsAndCompilers(compiler, opts);
  return compilerWithPlugins;
}

function sync(mdx) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var compiler = createCompiler(options);
  var fileOpts = {
    contents: mdx
  };

  if (options.filepath) {
    fileOpts.path = options.filepath;
  }

  var _compiler$processSync = compiler.processSync(fileOpts),
      contents = _compiler$processSync.contents;

  return "/* @jsx mdx */\n".concat(contents);
}

function compile(_x) {
  return _compile.apply(this, arguments);
}

function _compile() {
  _compile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(mdx) {
    var options,
        compiler,
        fileOpts,
        _yield$compiler$proce,
        contents,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            compiler = createCompiler(options);
            fileOpts = {
              contents: mdx
            };

            if (options.filepath) {
              fileOpts.path = options.filepath;
            }

            _context.next = 6;
            return compiler.process(fileOpts);

          case 6:
            _yield$compiler$proce = _context.sent;
            contents = _yield$compiler$proce.contents;
            return _context.abrupt("return", "/* @jsx mdx */\n".concat(contents));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _compile.apply(this, arguments);
}

compile.sync = sync;
module.exports = compile;
exports = compile;
exports.sync = sync;
exports.createMdxAstCompiler = createMdxAstCompiler;
exports.createCompiler = createCompiler;
exports.default = compile;